import { render, staticRenderFns } from "./EdgeConfig.vue?vue&type=template&id=f80105b0&scoped=true&"
import script from "./EdgeConfig.vue?vue&type=script&lang=js&"
export * from "./EdgeConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80105b0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormElement: require('/opt/buildhome/repo/components/form/FormElement.vue').default})
